export default "__VITE_PUBLIC_ASSET__3066e0e8__"